export default __webpack_public_path__ + "static/media/hht2_direction_speakingbooster_01.2e86fbfd.png";